;(function( window, document, $, undefined ) {
  'use strict';

  var shows = (function() {

    var $private = {};
    var $public = {};
    var screen_width = $(window).width();

    $public.mainSlider = function() {
      var mainSlider = $('.dd-main-bxslider').bxSlider({
        controls: false,
        pager: true,
        auto: true,
        pause: 5000,
        onSlideAfter: function() {
          mainSlider.stopAuto();
          mainSlider.startAuto();
        },
        onSliderLoad : function() {
          $('.dd-section-main-slider').css('visibility' , 'visible');
          if($(".dd-main-bxslider li").length < 4) {
            $('.dd-arrows-banner').hide();
            $('.bx-controls').hide();
          }
        }
      });

      $('.dd-arrows-banner .dd-arrow-left').on('click', function(){
        mainSlider.goToPrevSlide();
      });

      $('.dd-arrows-banner .dd-arrow-right').on('click', function(){
        mainSlider.goToNextSlide();
      });
    }

    $public.tabShows = function() {

      $('#btn-buy-ticket').click(function() {
        $("#tabs li").eq(0).click();
      });

      // Verificação ao entrar na página
      var urlHash = location.hash;
      var listTab = $('.dd-list-tab');
      var itemTab = $('.dd-list-tab li');

      if (!urlHash) {
        var tab = $('#tabs li:first-of-type').attr('data-hash');
        $('#tabs li:first-of-type').addClass("dd-active-tab");

        $(".dd-tab-page").find("[data-tab='" + tab + "']").addClass("dd-page-active");

      } else if (urlHash == '#compre-seu-ingresso') {
        $('li[data-hash="#pontos-de-venda"]').addClass("dd-active-tab");
        $(".dd-tab-page").find("[data-tab='#pontos-de-venda']").addClass("dd-page-active");
      } else {
        $(".dd-list-tab li.dd-active-tab").removeClass("dd-active-tab");
        $(listTab).find("[data-hash='" + urlHash + "']").addClass("dd-active-tab");

        $(".dd-content-page.dd-page-active").removeClass("dd-page-active");
        $(".dd-tab-page").find("[data-tab='" + urlHash + "']").addClass("dd-page-active");
      }


      //Trocando de tab ao clicar
      $(itemTab).click(function(){
        if (!$(this).hasClass("dd-active-tab")) {
          var tabHash = $(this).attr('data-hash');

          $(".dd-list-tab li.dd-active-tab").removeClass("dd-active-tab");
          $(this).addClass("dd-active-tab");

          $(".dd-content-page.dd-page-active").removeClass("dd-page-active");
          $(".dd-tab-page").find("[data-tab='" + tabHash + "']").addClass("dd-page-active");
        }

        var clickedHash = $(this).attr('data-hash');
        window.location.hash = clickedHash;

      });
    }

    $public.accordionLink = function(){
      $('.dd-link-accordion').click(function(){
        $(this).next().slideToggle();

        $(this).find('.dd-icon-more').text($(this).find('.dd-icon-more').text() == '[+]' ? '[-]' : '[+]');

      });
    }

    $public.titleHeight = function() {
      var maxHeight = 0;

      $(".dd-section-shows .dd-title").each(function(){
         if ($(this).height() > maxHeight) {
           maxHeight = $(this).height();
         }
      });

      $(".dd-section-shows .dd-title").css('min-height', maxHeight+'px');

    }

    return $public;
  })();

  // Global
  window.shows = shows;
  shows.tabShows();
  shows.accordionLink();
  shows.titleHeight();
  shows.mainSlider();

})( window, document, jQuery );

$(window).load(function() {
});
